import React from "react";
import { ShieldAlert, Ban, Clock, ExternalLink } from "lucide-react";
import JeaCard from "@/components/jea/JeaCard";

/**
 * Automatic Stay Explainer — displays the 11 U.S.C. § 362 warning.
 * Static content; no data dependency.
 */
const StayExplainerCard = () => (
  <JeaCard
    className="border-danger/50"
    data-testid="stay-explainer-card"
    style={{ background: "linear-gradient(180deg, rgba(231,76,60,0.08) 0%, rgba(231,76,60,0.02) 100%)" }}
  >
    <div className="flex items-start gap-4">
      <div className="shrink-0 w-11 h-11 rounded-full bg-danger/15 border border-danger/40 flex items-center justify-center">
        <ShieldAlert size={22} className="text-danger" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h2 className="text-white font-bold text-[18px]">Automatic Stay in Effect</h2>
          <span className="jea-caseno text-[11px] px-2 py-[2px] rounded-full bg-bg-tertiary border border-border-default">
            11 U.S.C. § 362
          </span>
        </div>
        <p className="text-text-secondary text-[13px] mt-2 leading-6">
          The moment a bankruptcy petition is filed, an <strong className="text-white">automatic
          stay</strong> halts all collection activity against the debtor. Willful violations expose
          creditors to sanctions, damages, and attorney-fee liability.
        </p>

        <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-3">
          <div className="p-3 rounded-[8px] bg-bg-primary border border-border-default">
            <div className="flex items-center gap-2 text-danger text-[12px] font-semibold uppercase tracking-[0.08em]">
              <Ban size={14} /> Do NOT
            </div>
            <ul className="mt-2 text-[12px] text-text-secondary space-y-1 leading-5 list-disc list-inside">
              <li>Serve garnishments or writs</li>
              <li>Contact debtor to collect</li>
              <li>Record new judgment liens</li>
              <li>Continue pending lawsuits</li>
            </ul>
          </div>
          <div className="p-3 rounded-[8px] bg-bg-primary border border-border-default">
            <div className="flex items-center gap-2 text-success text-[12px] font-semibold uppercase tracking-[0.08em]">
              <Clock size={14} /> DO
            </div>
            <ul className="mt-2 text-[12px] text-text-secondary space-y-1 leading-5 list-disc list-inside">
              <li>File Proof of Claim by bar date</li>
              <li>Monitor § 341 meeting outcome</li>
              <li>Preserve existing perfected liens</li>
              <li>Consult bankruptcy counsel</li>
            </ul>
          </div>
          <div className="p-3 rounded-[8px] bg-bg-primary border border-border-default">
            <div className="flex items-center gap-2 text-warning text-[12px] font-semibold uppercase tracking-[0.08em]">
              <ExternalLink size={14} /> If Urgent
            </div>
            <ul className="mt-2 text-[12px] text-text-secondary space-y-1 leading-5 list-disc list-inside">
              <li>Motion for Relief from Stay (§ 362(d))</li>
              <li>Objection to Dischargeability (§ 523)</li>
              <li>Adversary proceeding (§ 727)</li>
              <li>Watch for conversion / dismissal</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </JeaCard>
);

export default StayExplainerCard;
